export const ADMIN_ID = 'GoManila Helpdesk Support';

export default {}